export default __webpack_public_path__ + "static/media/kalingo-right-arrow.50c06592.svg";